// extracted by mini-css-extract-plugin
module.exports = {"styledDropdown":"GqCK6BJ4"};